export class PVAWidget {
    constructor() {
        this._options = {};
        this._touched = false;
        this._ausgaben = document.querySelector('#ausgaben');
        this.postdeliveryInfo = document.querySelector('.postdelivery');
        this.pvaMandants = document.querySelectorAll('.mandanten');
        this.pvaImgs = document.querySelectorAll('.ausgaben');
        this.continueOrder = document.querySelector('#continueOrder');

        this.init();
    };
    
    get value() {
        return this._ausgaben.value;
    }
    
    get title() {
        return (this._options[this._ausgaben.value]) ? this._options[this._ausgaben.value].title : '';
    }
    
    get mandant() {
        return (this._options[this._ausgaben.value]) ? this._options[this._ausgaben.value].mandant : '';
    }
    
    get postdelivery() {
        return (this._options[this._ausgaben.value]) ? Boolean(this._options[this._ausgaben.value].postdelivery) : false;
    }
    
    get device() {
        return (this._options[this._ausgaben.value]) ? this._options[this._ausgaben.value].device : false;
    }
    
    get price() {
        return (this._options[this._ausgaben.value]) ? this._options[this._ausgaben.value].price : false;
    }

    get touched() {
        return this._touched;
    }
    
    set value(value) {
        this._ausgaben.value = value;
        this._pva = value;
        this.updatePvaHolder();
    }

    set touched(value) {
        this._touched = value;
    }

    init() {
        if (this.continueOrder) {
            this.continueOrder.addEventListener('click', (event) => {
                event.preventDefault();
                this.postdeliveryInfo.classList.add('d-none');
                OVS.app.helper.show('.postdeliveryToggle');
            });
        }
    }

    singleCheck() {
        if (this._ausgaben) {
            Array.from(this._ausgaben.options).forEach(option => {
                this._options[option.dataset.pva] = {
                    title : option.text,
                    pva : option.dataset.pva,
                    selected : (option.value == this._ausgaben.value),
                    price : option.dataset.price ?? [],
                    mandant : option.dataset.mandant,
                    postdelivery : option.dataset.postdelivery,
                    device : option.dataset.device,
                };
            });
            OVS.app.helper.singleSelect(this._ausgaben);
        }
    };
    
    update(options = []) {
        if(options.length) {
            this._ausgaben.innerHTML = '';
            options.forEach(element => {
                let option = new Option(element.title, element.pva);
                this._ausgaben.add(option, null);
                this._options[element.pva] = element;
                
                if(element.selected) {
                    this.value = option.value;
                }
            });
            
            OVS.app.helper.singleSelect(this._ausgaben);
            this.checkPostDelivery();
        }
    };
    
    updatePvaHolder() {
        if(this.pvaMandants) {
            this.pvaMandants.forEach(element => {
                element.classList.add('d-none');
            });
        }
        
        if(this.pvaImgs) {
            this.pvaImgs.forEach(element => {
                element.classList.add('d-none');
            });
        }
        
        if (this.value) {
            OVS.app.helper.removeClass('.ausgabe-' + this.value, 'd-none');
        }

        if (this.mandant) {
            OVS.app.helper.removeClass('.mandant-' + this.mandant, 'd-none');
        }
        
        this.checkPostDelivery();
    };
    
    checkPostDelivery() {
        if (this.postdelivery) {
            this.postdeliveryInfo.classList.remove('d-none');
            OVS.app.helper.hide('.postdeliveryToggle');
        } else {
            this.postdeliveryInfo.classList.add('d-none');
            OVS.app.helper.show('.postdeliveryToggle');
        }
    }
}
